module.exports = __WEBPACK_EXTERNAL_MODULE__71__;